import React, { useEffect, useState } from 'react'
import {PDFDownloadLink} from '@react-pdf/renderer'
import ModalAntesDescargarPDFLiquidacionQx from './ModalAntesDescargarPDFLiquidacionQx'
import { postActualizarProcirLiquidacionQx, postDataParaInserttmpfac, postDeleteTMPTMPLiquidacionQx, postInformacionEmpresa, postInsertDataTMPFAC1 } from '../../../services/PaginaRuta'
import Loading from '../../Loading'
import ModalPDFPaquetesYFormasLiquidar from './ModalPDFPaquetesYFormasLiquidar'

const ModalConfirmarLiquidacionPaqueteYFormasLiquidar = ({setmodalOnConfirmarLiquidacion,dataPrecios,dataProcedimientos,dataPDF,dataUser,dataPreciosPDF,handleCancelClickLiquidacion,setactualizarDataLiquidacion,dataAnestesiologo,agrupadorMULTBILAINDV,totalPrecioProcedimiento,complicacionesDx,arrayProcedimientosProcedimiento, valorTotalProcedimientos}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));  
  const [informacionEmpresa,setinformacionEmpresa]=useState({
    EMPCOD: "",
    EmpNit: "",
    EmpRazSoc: "",
    MCDnom: "",
    MCDpto: "",
    T2_EMPCOD: "",

  })  
  const [loading,setloading]=useState(false)
  const handleCancelarClick=()=>{
        setmodalOnConfirmarLiquidacion(false)
        
    }
   
    const handleOnclickConfirmarLiquidacion =()=>{
      
        //const valorTotalProcedimientos = dataPreciosPDF.reduce((acumulador, producto) => acumulador + producto.precioProcedimiento, 0);
        setTimeout(() => {  
          setloading(true)
        //todos los honorarios de todos los procedimientos qx de un usuario
        let precios = [].concat(...dataPreciosPDF.map(obj => obj.precios));
        //console.log(precios,'PRECIOSSSSSSSSSSSS');
        ////
        let arrayProcedimientosFacturables = dataPreciosPDF.map(procedimiento => {
          const isFacturable = procedimiento.precios.every(precio => precio.tipoHojaFact === 'F');
          return {...procedimiento, isFacturable};
        });
        //console.log(arrayProcedimientosFacturables,'FATURABLES');

        ///
        let arrayUnionVAriablesFaltantes = precios.map(obj1 => {
          const obj2 = dataPreciosPDF.find(obj2 => obj2.CrgCod.trim() === obj1.CodigoProcedimiento.trim());
          //console.log(obj2,'obj2')
          if (obj2) {
              return {...obj1, precioTotalProcedimiento: obj2.precioProcedimiento, via: obj2.via, opcion: obj2.opcion, especilidadCirujano: obj2.especilidadCirujano, TpPrCd: obj2.TpPrCd, agrupadorProcedimiento: obj2.agrupadorProcedimiento       };
          } else {
              return obj1;
          }
      });

      console.log(arrayUnionVAriablesFaltantes,'arrayUnionVAriablesFaltantes')
      
        const dataInsert={
            TFCedu:dataUser.MPCedu,
            TFTDoc:dataUser.MPTDoc,
            TmCtvIng:dataUser.ProCtvIn
          }
          
          

          
        
          
                  
            //postDataParaInserttmpfac(dataInsert).then((insert)=>{
              //let TFHISCSEC = insert.data[0].TFHISCSEC
              const actualizarProcir={
                  ProEmpCod:usuarioInfo.Empresa,
                  ProMCDpto:usuarioInfo.Sede,
                  ProCirCod: dataUser.ProCirCod,
                  ProEsta:'5'
                }
                postActualizarProcirLiquidacionQx(actualizarProcir).then((response)=>{
                  
                  //let fecha = new Date();
                  //let año = fecha.getFullYear();
                  //let mes = ("0" + (fecha.getMonth() + 1)).slice(-2); // Los meses en JavaScript son base 0, así que añadimos 1
                  //let dia = ("0" + fecha.getDate()).slice(-2);
                  //let horas = ("0" + fecha.getHours()).slice(-2);
                  //let minutos = ("0" + fecha.getMinutes()).slice(-2);
                  //let segundos = ("0" + fecha.getSeconds()).slice(-2);
                  //let milisegundos = ("00" + fecha.getMilliseconds()).slice(-3); // En caso de milisegundos que sean menos de 100
                  //let fechaFormateada = `${año}-${mes}-${dia} ${horas}:${minutos}:${segundos}.${milisegundos}`;
                  //let soloFecha = `${año}-${mes}-${dia} 00:00:00.000`
  
                  //formas de liquidacion
                  const insertTableHonorariosProcedimientos= arrayUnionVAriablesFaltantes.map((item)=>{
                    return {
                              "TFFchP": dataUser.ProFec,
                              "TFProc": "2",              //ClasedeProcedimiento
                              "TFPerA": "7",              //Personal que atiende
                              "TFPrC1": item.CodigoProcedimiento,         //C�digoProcedimiento
                              "TFVaTP": `${item.ValorHonorarioImprLiqCir}`,          ////ValorTotalServicio
                              "TFNomA": "",               //NombredequienAutoriza
                              "TFUPro": usuarioInfo.UsuarioEncriptado,     //UsuarioTramitaProcedimiento
                              "TFUVRVLR":item.CantidadUVR,            //ValorUVR
                              "TFUVRCOD":item.CodigoFormaLiquidacion, //Formadeliquidaci�n
                              "TFCanpr":"1",              //CantidadSuministro ///1 FALTADANIEL
                              "TFCopa": "0",              //TipoCuotacoopago
                              "TFCoMo": "0",              //AplicaCuotaModeradora
                              "TFinte": `${item.ValorHonorarioImprLiqCir}`,        //ValorUnitario, Valor total integral
                              "TFPCSO": `${item.agrupadorProcedimiento}`,           //TipodeProcedimientoQx VALIDARFALTA
                              "TFOpcn": "2",              //Opcion(Electiva/Trauma) RONALD
                              "TFPCodCCs": usuarioInfo.Sede,         //sede
                              "TFPCodSCC": dataUser.CNCCOD,      //C�digo centro decosto 
                              "TFPTpoTrn": item.tipoHojaFact, //tipo de transaccion
                              "TFPFchReg": dataUser.ProFec, ///fecha agendo el procedimiento
                              "TFPinte": "0",             //% PorIntegral
                              "TFCodPab": dataPDF.TFcCodPab, //CodigoPabellon
                              "TFCoRecar":"N",            //El procedimiento manejar recargo S/N
                              "TFPCodEmp": usuarioInfo.Empresa,           //Empresa
                              "TFDiPr": dataUser.DiaSal,//"R100",           //Descripcion Dx Previo 
                              "TFHnrCod": item.CodigoHonorario,           //C􀀁digo Honorario
                              "TFDiPP": dataUser.DiaSal,//"R100",           //Descripcion Dx Posterior
                              "TFPHoMe":`${item.PorcOrden / 100}` ,          //%HonorariosMedicos,
                              "MMcoM1": item.CodigoMedico,          //C�digoMedico
                              "MECoM1": item.CodigoEspecialidad,            //C�digoEspecialidad VALIDAR bases de datos
                              "TFDiCo": `${complicacionesDx? complicacionesDx.DxCompl: ""}`,               //C�digo Diag. Complicaci�n 
                              "TFVlrTot": `${item.precioTotalProcedimiento}`,        //valorTotalLiquidacionQx
                              "TFVias": item.via,              //vias 
                              "TFEspe": item.especilidadCirujano,              //Especialidad(igual/diferente) 
                              "TFNGrp": "01",             //GrupoQuirurgico
                              "TFHISCSEC": "0",           //folio FALTA
                              "TFEstaAnu1": "N",          //Estado de Anulacion Procedimientos Anulado='S', No anulado = 'N' //igual
                              "TFCodCir": dataUser.ProCirCod, //NumerodeCirugia 
                              "TFPPPCod": "",             //Codigo Programa PYP
                              "TFOrdMan": "N",            //Indicador de orden manual en cirugias mult /
                              "TFPPorIva": "0",           //Porcentaje de impuesto aplicado al procedimiento 
                              "TFPVlrSIv": `${item.ValorHonorarioImprLiqCir}`,//YA QUEDO LISTO
                              "TFOrdLiq": `${item.NumeroOrden}`,           //Orden de Liquidaci�n  //FALTA
                              "TFCnaqX": "1",            //Consecutivo de agrupador
                              "TFIMPPRC": "0",            //Valor individual de impuesto aplicado al procedimiento
                              "TFPCODIMPP": "",           //Codigo de impuesto que aplica al procedimiento
                              "TFAUTPRO": "",
                              "TFTipP": `${item.TpPrCd}`,               //Tipo de Procedimiento
                              "TFHorP": "",
                              "TFConP": "",
                              "TFEPro": "",
                              "TFFPro": "",
                              "TFHPro": "",
                              "TFCodCam":"",
                              "ViaCod":"",
                              "TFUsuAnl":"",
                              "TFNCITA": "0",
                              "TFPorImpt": "0",
                              "TFFchAnu1": "N",
                              "TFEsParXTo": "0",
                              "TFConPr": "0",
                              "TFIndCop": "",
                              "TFCodPar": "",
                              "TFIFacPro": "",
                              "TFNumA": "",
                              "TFNumAuE": "0",
                              "TFCtvEnt": "0",
                              "TFCodCon": "",
                              "TFPCaue": "0",
                              "TFCODPQT": "",
                              "TFTIPLIQP": "",
                              "TFFINAL": "",
                              "TFCodAnuP": "",
                              "TFCodFinal": "",
                              "TFpEtEnT": "0",
                              "TFPCODHOM": "0", 
                              "TFPCNSPAQ": "0",
                              "TFPCTEPAQ": "0",
                              "TFREAPTR": "",
                              "TFANCATR": ""
                    }
                  })

                  //liquidacion paquete
                  const insertTableHonorariosProcedimientosPaquete= arrayProcedimientosProcedimiento.map((item)=>{
            return {
                      "TFFchP": dataUser.ProFec,
                      "TFProc": "2",              //ClasedeProcedimiento
                      "TFPerA": "7",              //Personal que atiende
                      "TFPrC1": item.CodigoProcedimiento,         //C�digoProcedimiento
                      "TFVaTP": `${item.precioPorcentajeProcedimiento}`,          ////ValorTotalServicio
                      "TFNomA": "",               //NombredequienAutoriza
                      "TFUPro": usuarioInfo.UsuarioEncriptado,     //UsuarioTramitaProcedimiento
                      "TFUVRVLR":item.CantidadUVR,            //ValorUVR
                      "TFUVRCOD":'',//item.CodigoFormaLiquidacion, //Formadeliquidaci�n//FALTALLLL
                      "TFCanpr":"1",              //CantidadSuministro ///1 FALTADANIEL
                      "TFCopa": "0",              //TipoCuotacoopago
                      "TFCoMo": "0",              //AplicaCuotaModeradora
                      "TFinte": `${item.precioPorcentajeProcedimiento}`,        //ValorUnitario, Valor total integral
                      "TFPCSO": `${item.agrupadorProcedimiento}`,           //TipodeProcedimientoQx MULT,INDV,BILA
                      "TFOpcn": "2",              //Opcion(Electiva/Trauma) RONALD
                      "TFPCodCCs": usuarioInfo.Sede,         //sede
                      "TFPCodSCC": item.CodigoSubCCosto,      //C�digo centro decosto 
                      "TFPTpoTrn": item.tipoHojaFact, //tipo de transaccion facturacion F o hoja de gasto H
                      "TFPFchReg": dataUser.ProFec, ///fecha agendo el procedimiento
                      "TFPinte": "0",             //% PorIntegral
                      "TFCodPab": dataPDF.TFcCodPab, //CodigoPabellon
                      "TFCoRecar":"N",            //El procedimiento manejar recargo S/N
                      "TFPCodEmp": usuarioInfo.Empresa,           //Empresa
                      "TFDiPr": dataUser.DiaSal,//"R100",           //Descripcion Dx Previo 
                      "TFHnrCod":item.CrgHnrCi,           //C􀀁digo Honorario // puede ir en blanco FALTALLLLL
                      "TFDiPP": dataUser.DiaSal,//"R100",           //Descripcion Dx Posterior
                      "TFPHoMe": "0",//`${item.PorcOrden / 100}` ,          //%HonorariosMedicos, FALTA
                      "MMcoM1": item.MedCod,          //C�digoMedico
                      "MECoM1": item.EspcCod,            //C�digoEspecialidad VALIDAR bases de datos
                      "TFDiCo": `${complicacionesDx? complicacionesDx.DxCompl: ""}`,               //C�digo Diag. Complicaci�n 
                      "TFVlrTot": `${item.precioTotalProcedimiento}`,        //valorTotalLiquidacionQx
                      "TFVias": item.via,              //vias 
                      "TFEspe": item.especilidadCirujano,              //Especialidad(igual/diferente) 
                      "TFNGrp": "01",             //GrupoQuirurgico
                      "TFHISCSEC": "0",           //folio FALTA
                      "TFEstaAnu1": "N",          //Estado de Anulacion Procedimientos Anulado='S', No anulado = 'N' //igual
                      "TFCodCir": dataUser.ProCirCod, //NumerodeCirugia 
                      "TFPPPCod": "",             //Codigo Programa PYP
                      "TFOrdMan": "N",            //Indicador de orden manual en cirugias mult /
                      "TFPPorIva": "0",           //Porcentaje de impuesto aplicado al procedimiento 
                      "TFPVlrSIv": `${item.precioPorcentajeProcedimiento}`,//Valor individual de procedimiento antes de impuesto
                      "TFOrdLiq": "1", //`${item.NumeroOrden}`,           //Orden de Liquidaci�n  //FALTA
                      "TFCnaqX": "1",            //Consecutivo de agrupador
                      "TFIMPPRC": "0",            //Valor individual de impuesto aplicado al procedimiento
                      "TFPCODIMPP": "",           //Codigo de impuesto que aplica al procedimiento
                      "TFAUTPRO": "",
                      "TFTipP": `${item.CodigoTipoProc}`,               //Tipo de Procedimiento
                      "TFHorP": "",
                      "TFConP": "",
                      "TFEPro": "",
                      "TFFPro": "",
                      "TFHPro": "",
                      "TFCodCam":"",
                      "ViaCod":"",
                      "TFUsuAnl":"",
                      "TFNCITA": "0",
                      "TFPorImpt": "0",
                      "TFFchAnu1": "N",
                      "TFEsParXTo": "0",
                      "TFConPr": "0",
                      "TFIndCop": "",
                      "TFCodPar": "",
                      "TFIFacPro": "",
                      "TFNumA": "",
                      "TFNumAuE": "0",
                      "TFCtvEnt": "0",
                      "TFCodCon": "",
                      "TFPCaue": "0",
                      "TFCODPQT": "",
                      "TFTIPLIQP": "",
                      "TFFINAL": "",
                      "TFCodAnuP": "",
                      "TFCodFinal": "",
                      "TFpEtEnT": "0",
                      "TFPCODHOM": "0", 
                      "TFPCNSPAQ": "0",
                      "TFPCTEPAQ": "0",
                      "TFREAPTR": "",
                      "TFANCATR": ""
            }
          })

                const unirDosArraysFormasLiquidacionYPaquete = [...insertTableHonorariosProcedimientos, ...insertTableHonorariosProcedimientosPaquete];
          
                  const dataInsertTMPFAC1 = {
                    "tipoIdentificacion": dataUser.MPTDoc,
                    "numIdentificacion": dataUser.MPCedu,
                    "consIngreso": `${dataUser.ProCtvIn}`,
                    "NumContrato": dataUser.ProEPS,
                    "cantidadProcedimientos": "1",
                    "datosProcQX": unirDosArraysFormasLiquidacionYPaquete
                  }
          
                  console.log(dataInsertTMPFAC1,'ULTIMO000000000')
                    
                    postInsertDataTMPFAC1(dataInsertTMPFAC1).then((res)=>{
                      console.log(res.data,'insertar data TMPFAC1')
                      const DeleteTMPTMP={
                          TmpUsr:usuarioInfo.UsuarioEncriptado,
                          TmpCedu: dataUser.MPCedu,
                          TmpTDoc:dataUser.MPTDoc,
                          TmpClPr:'2'
                        }
                        postDeleteTMPTMPLiquidacionQx(DeleteTMPTMP).then((res)=>{
                          console.log(res.data,'delete')
                          //setTimeout(() => {   
                            setmodalOnConfirmarLiquidacion(false)
                            handleCancelClickLiquidacion()
                            setactualizarDataLiquidacion(dataInsert)       
                            setloading(false)
                          //}, 1500);
                          
                          //setloading(false)
                        })
                    })
                })
  
            //})
            }, 1000);

       
    }

    console.log(dataUser,'  dataUser')

    useEffect(()=>{
      const datosEmpresa={
        "EMPCOD":usuarioInfo.Empresa,
     "MCDpto":usuarioInfo.Sede}
        postInformacionEmpresa(datosEmpresa).then((res)=>{
          if(res.data[0]){
            setinformacionEmpresa(res.data[0])
            console.log(res.data,'datos empresaa')
          }
          
        })
    },[])
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        {
          loading?
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Guardando Liquidación              
            </h5>
            
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
            <div className="text-center py-4"><Loading/></div>
            </div>
          </div>
          :
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Confirmar
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative p-4">
            <div className="flex py-2 text-left">
              <div className="w-3/3  px-4">
                <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  La Liquidación de Cirugía es correcta?
                </label>
              </div>
            </div>
          
          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              No
            </button>
            <PDFDownloadLink document={<ModalPDFPaquetesYFormasLiquidar dataPrecios={dataPrecios} dataProcedimientos={dataProcedimientos} dataPDF={dataPDF} dataUser={dataUser} dataPreciosPDF={dataPreciosPDF} dataAnestesiologo={dataAnestesiologo} totalPrecioProcedimiento={totalPrecioProcedimiento} informacionEmpresa={informacionEmpresa} dataProcedimientosPaquete={arrayProcedimientosProcedimiento} valorTotalProcedimientos={valorTotalProcedimientos}/> } fileName="confirmarLiquidacionPaqueteeee.pdf">
                <button
                type="button"
                onClick={handleOnclickConfirmarLiquidacion}
                className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                >
                Si
                </button>
            </PDFDownloadLink>
          </div>
          </div>
        </div>
        }
        
      </div>
    </div>
  )
}

export default ModalConfirmarLiquidacionPaqueteYFormasLiquidar